var React = require('react');

function ClearInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Zm9.576-3.637a.857.857 0 1 0-1.212 1.213L10.788 12l-2.424 2.424a.857.857 0 0 0 1.212 1.213L12 13.212l2.425 2.425a.857.857 0 0 0 1.212-1.213L13.212 12l2.425-2.424a.857.857 0 0 0-1.212-1.213L12 10.788 9.576 8.363Z","clipRule":"evenodd"}));
}

ClearInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ClearInline;

ClearInline.default = ClearInline;
